import NIIcon from 'assets/img/icons/products/nomad-insurance.svg';
import RHIcon from 'assets/img/icons/products/remote-health-companies.svg';

export const PRODUCTS = {
  NOMAD_INSURANCE: {
    name: 'nomad_insurance',
    title: 'Nomad Insurance',
    link: '/nomad-insurance/signup',
    description: 'Global travel medical insurance for nomads',
    bg: 'mint',
    icon: NIIcon
  },
  REMOTE_HEALTH: {
    name: 'remote_health',
    title: 'Remote Health',
    link: '/remote-health',
    description: 'Global health insurance for remote companies',
    color: 'indigo',
    bg: 'portGore',
    icon: RHIcon
  }
};
